import _ from 'lodash';
import React, { useMemo } from 'react';
import { isStrategyDomainUser } from 'ui/applicationDomainHelper';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { getContentList, getProContentList } from './ContentList.jsx';

const propTypes = {
  isPremium: PropTypes.bool,
  liveRunLimit: PropTypes.number,
  historicRunLimit: PropTypes.number,
  parentClassName: PropTypes.string,
  isPro: PropTypes.bool,
};

const defaultProps = {
  isPremium: false,
  liveRunLimit: 0,
  historicRunLimit: 0,
  parentClassName: '',
  isPro: false,
};

const PlanContent = ({ isPremium, liveRunLimit, historicRunLimit, parentClassName, isPro }) => {
  const renderContent = ({ content, id, isChecked }) => {
    const className = classNames('fa-solid', {
      'fa-square-check': isChecked,
      'fa-square': !isChecked,
    });

    const renderSpan = isChecked ? (
      <span>{content}</span>
    ) : (
      <span>
        <del>{content}</del>
      </span>
    );

    return (
      <React.Fragment key={id}>
        <li>
          <div>
            <i className={className} />
          </div>
          <div>{renderSpan}</div>
        </li>
      </React.Fragment>
    );
  };

  const ulClassName =
    parentClassName ||
    classNames({
      'pro-plan-list': isPro,
      'premium-plan-list': isPremium,
      'plan-list': !isPremium,
    });

  const currentPlanContent = useMemo(() => {
    let defaultPlanList;

    const contentList = getContentList(isPremium, historicRunLimit, liveRunLimit);
    defaultPlanList = isStrategyDomainUser() ? _.takeRight(contentList, 2) : contentList;

    const proPlanList = getProContentList(isPro, historicRunLimit, liveRunLimit);

    return isPro ? proPlanList : defaultPlanList;
  }, [isPro, isPremium, historicRunLimit, liveRunLimit]);

  return <ul className={ulClassName}>{_.map(currentPlanContent, renderContent)}</ul>;
};

PlanContent.propTypes = propTypes;
PlanContent.defaultProps = defaultProps;

export default PlanContent;
